import common from './commonUtils';
import crmCommon from './crmCommonUtils';

export default {
  common,
  crmCommon
}



// WEBPACK FOOTER //
// ./src/common/mixins/index.js